export var BankAccountType;
(function (BankAccountType) {
    BankAccountType["CHECKING"] = "checking";
    BankAccountType["SAVINGS"] = "savings";
})(BankAccountType || (BankAccountType = {}));
export const bankAccountTypeLabel = (accountType) => {
    switch (accountType) {
        case BankAccountType.CHECKING:
            return 'Checking';
        case BankAccountType.SAVINGS:
            return 'Savings';
        default:
            throw new Error('Invalid bank account type');
    }
};
export var BankAccountProduct;
(function (BankAccountProduct) {
    BankAccountProduct["LOAN"] = "loan";
    BankAccountProduct["MORTGAGE"] = "mortgage";
})(BankAccountProduct || (BankAccountProduct = {}));
